/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GetLatestHeaders = zod.object({
  'X-Content-Grant-Pin': zod
    .string()
    .optional()
    .describe(
      'PIN challenge answer for a PIN-protected `accessGrantUuid`. A header so it never enters a URL, a log line or a cache key.',
    ),
});

export type GetLatestHeaders = zod.input<typeof GetLatestHeaders>;
export type GetLatestHeadersOutput = zod.output<typeof GetLatestHeaders>;
